var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, css, html, LitElement } from "lit-element";
import axios from "axios";
import i18n from 'roddeh-i18n';
let FacebookAuthButton = class FacebookAuthButton extends LitElement {
    constructor() {
        super();
        this.authError = null;
    }
    onFbSignIn() {
        this.authError = null;
        const _window = window;
        if (_window.FB !== undefined) {
            this.dispatch('signing', {});
            _window.FB.getLoginStatus((response) => {
                this.statusChangeCallback(response);
            });
        }
    }
    statusChangeCallback(response) {
        const _window = window;
        if (_window.FB !== undefined) {
            if (response.status === "connected") {
                if (response.authResponse && response.authResponse.accessToken) {
                    this.facebookSignIn(response.authResponse.accessToken, response.authResponse.userID);
                }
            }
            else {
                _window.FB.login((response) => {
                    if (response.authResponse && response.authResponse.accessToken) {
                        this.facebookSignIn(response.authResponse.accessToken, response.authResponse.userID);
                    }
                }, {
                    scope: "public_profile, email"
                });
            }
        }
    }
    dispatch(name, details) {
        const event = new CustomEvent(name, {
            detail: details,
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(event);
    }
    facebookSignIn(accessToken, userId) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        axios.post("/facebook/tokensignin", { token: accessToken, user_id: userId })
            .then(response => {
            if (!response.data.logged && response.data.first_name && response.data.last_name) {
                let email = null;
                if (response.data.email && !response.data.email.endsWith('facebook.com')) {
                    email = response.data.email;
                }
                this.dispatch('signed', {
                    type: 'account_created',
                    source: 'Facebook',
                    firstName: response.data.first_name,
                    lastName: response.data.last_name,
                    email: email,
                });
            }
            else {
                if (response.data.logged) {
                    const data = {
                        type: 'logged',
                        firstName: response.data.first_name,
                        lastName: response.data.last_name
                    };
                    if (typeof (response.data.redirect_to) !== 'undefined') {
                        data.redirectTo = response.data.redirect_to;
                    }
                    this.dispatch('signed', data);
                }
                else {
                    const data = {};
                    if (typeof (response.data.message) !== 'undefined') {
                        data.message = response.data.message;
                        this.showErrors(data);
                    }
                    this.dispatch('canceled', data);
                }
            }
        }).catch((error) => {
            const data = {};
            if (typeof (error.response) !== 'undefined' && typeof (error.response.data.message) !== 'undefined') {
                data.message = error.response.data.message;
                this.showErrors(data);
            }
            this.dispatch('canceled', data);
        });
    }
    showErrors(data) {
        let error;
        if (typeof (data.message) === 'undefined') {
            error = i18n('An unknown error occurred. Please try again later');
        }
        else {
            error = data.message;
        }
        this.authError = error;
        this.requestUpdate();
    }
    static get styles() {
        return css `
        :host {
            cursor: pointer;
            user-select: none;
            display: inline-block;
        }

        #fbSignInWrapper{
            display: inline-block;
        }

        #fbCustomBtn {
            display: flex;
            background-color: #4267b2;
            color: #fff;
            width: 280px;
            padding: 4px 4px;
            align-items: center;
            transition: background-color 0.3s ease-out;
         }

         #fbCustomBtn:hover{
            cursor: pointer;
            background-color: #335395;
         }

        #fbCustomBtn span.text{
            flex: 1;
            text-align: center;
            font-weight: bold;
            font-family: "Roboto", sans-serif;
            font-size: 14px;
            vertical-align: middle;
         }

        #fbCustomBtn span.icon{
            background: url("/img/facebook-icon.svg") no-repeat;
            display: inline-block;
            vertical-align: middle;
            width: 32px;
            height: 32px;
            background-size: 100%;
         }
         .error {
            background-color: #ffd1d1;
            padding: 0.5em;
            box-sizing: border-box;
            color: #b30000;
            width: 288px;
            font-size: 0.8em;
            font-weight: 600;
            text-align: center;
            cursor: default;
         }
        `;
    }
    render() {
        return html `<div id="fbSignInWrapper">
              <div id="fbCustomBtn" @click="${this.onFbSignIn}" >
                <span class="icon"></span>
                <span class="text">${i18n('NRF Log in using Facebook')}</span>
              </div>
              ${this.authError !== null ? html `
              <div class="error">
                  ${this.authError}
              </div>
              ` : ''}
            </div>`;
    }
};
__decorate([
    property({ type: String })
], FacebookAuthButton.prototype, "authError", void 0);
FacebookAuthButton = __decorate([
    customElement('facebook-auth-button')
], FacebookAuthButton);
export default FacebookAuthButton;
